import { learningAlphaApi, learningApi } from '@lumapps/learning/constants';

export const GetBaseUrl = (sameCluster = false) => {
    return sameCluster ? learningAlphaApi.URL : learningApi.URL;
};
